export default __webpack_public_path__ + "static/media/04.04feb484.png";